<template>
  <section class="dl-hero">
    <div class="dl-hero__bg" aria-hidden="true">
      <span class="dl-hero__orb dl-hero__orb--1" />
      <span class="dl-hero__orb dl-hero__orb--2" />
    </div>

    <div class="dl-hero__wrap">
      <div class="dl-hero__card">
        <div class="dl-hero__inner">
        <div class="dl-hero__copy">
          <p class="dl-hero__label">ANDROID · APK</p>
          <h1 class="dl-hero__title">Download Secure VPN APK Free</h1>
          <p class="dl-hero__desc">
            Get the latest Secure VPN APK for Android and enjoy a fast, simple, and private VPN connection.
            Install it directly on your device — no Google Play required.
          </p>

          <ul class="dl-hero__meta">
            <li><strong>2026</strong><span>Latest version</span></li>
            <li><strong>APK</strong><span>File type</span></li>
            <li><strong>Free</strong><span>Price</span></li>
          </ul>

          <a
            class="dl-hero__btn"
            :href="apkDownloadUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Secure VPN APK
            <span aria-hidden="true">→</span>
          </a>
        </div>

        <div class="dl-hero__visual" aria-hidden="true">
          <div class="dl-hero__glow" />
          <img
            class="dl-hero__art"
            :src="heroArt"
            alt=""
            width="480"
            height="360"
            loading="eager"
            decoding="async"
          >
          <span class="dl-hero__stamp">100%<br>FREE</span>
        </div>
        </div>
      </div>
    </div>

    <div class="dl-hero__wave" aria-hidden="true">
      <svg viewBox="0 0 1440 64" preserveAspectRatio="none">
        <path d="M0 32c240 48 480-16 720 16s480-16 720 16v32H0V32z" fill="#f4f8ff" />
      </svg>
    </div>
  </section>
</template>

<script>
import heroArt from '@/assets/myvpnbook/download-apk-hero.svg'

const APK_DOWNLOAD_URL =
  process.env.VUE_APP_DEFAULT_APK ||
  'https://apk.secureproxyvpn.com/android/apk/SecureVPN-release-1.0.2_c-20260710171019.apk'

export default {
  name: 'DownloadHeroSection',
  data() {
    return {
      heroArt,
      apkDownloadUrl: APK_DOWNLOAD_URL,
    }
  },
}
</script>

<style lang="scss" scoped>
.dl-hero {
  position: relative;
  overflow: hidden;
  padding: 28px 0 0;
  background: var(--vpn-page, #f4f8ff);
}

.dl-hero__bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.dl-hero__orb {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(27, 111, 232, 0.14) 0%, transparent 70%);
}

.dl-hero__orb--1 {
  width: 300px;
  height: 300px;
  top: -60px;
  right: 6%;
}

.dl-hero__orb--2 {
  width: 180px;
  height: 180px;
  bottom: 60px;
  left: 4%;
  opacity: 0.75;
}

.dl-hero__wrap {
  position: relative;
  z-index: 1;
  width: var(--vpn-content-width);
  max-width: 100%;
  margin: 0 auto;
  padding-bottom: 8px;
}

.dl-hero__card {
  padding: 28px 32px;
  border-radius: 24px;
  border: 1px solid var(--vpn-line, #dce6f5);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(238, 244, 252, 0.98) 100%);
  box-shadow: var(--vpn-shadow, 0 12px 40px rgba(27, 111, 232, 0.12));
  box-sizing: border-box;
}

.dl-hero__inner {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px 20px;
  align-items: center;
  justify-content: space-between;
}

.dl-hero__label {
  margin: 0 0 12px;
  color: #7a8da8;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
}

.dl-hero__title {
  margin: 0;
  max-width: 560px;
  font-size: clamp(30px, 4.2vw, 48px);
  line-height: 1.12;
  letter-spacing: -0.03em;
  font-weight: 800;
  color: var(--vpn-ink, #0f172a);
}

.dl-hero__desc {
  margin: 16px 0 22px;
  max-width: 520px;
  color: var(--vpn-ink-muted, #5b6478);
  font-size: 17px;
  line-height: 1.65;
}

.dl-hero__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0 0 26px;
  padding: 0;
  list-style: none;

  li {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 88px;
    padding: 10px 14px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.85);
    border: 1px solid var(--vpn-line, #dce6f5);
  }

  strong {
    font-size: 15px;
    color: var(--vpn-ink, #0f172a);
  }

  span {
    font-size: 12px;
    color: var(--vpn-ink-muted, #5b6478);
  }
}

.dl-hero__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 52px;
  padding: 0 28px;
  border-radius: var(--vpn-radius-pill, 999px);
  background: var(--vpn-brand, #1b6fe8);
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  box-shadow: var(--vpn-shadow-btn);
  transition: transform 0.2s ease, background 0.2s ease;

  &:hover {
    background: var(--vpn-brand-deep, #1558c0);
    transform: translateY(-1px);
  }
}

.dl-hero__visual {
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(300px, 34vw);
  min-height: 220px;
}

.dl-hero__glow {
  position: absolute;
  inset: 8% 10% 12%;
  border-radius: 28px;
  background: radial-gradient(circle at 40% 35%, rgba(27, 111, 232, 0.2), transparent 68%);
  filter: blur(16px);
  pointer-events: none;
}

.dl-hero__art {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  max-width: 260px;
  height: auto;
}

.dl-hero__stamp {
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 88px;
  height: 88px;
  border-radius: 50%;
  background: linear-gradient(145deg, #34d399, #16a34a);
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  line-height: 1.15;
  text-align: center;
  box-shadow: 0 12px 28px rgba(22, 163, 74, 0.35);
}

.dl-hero__wave {
  position: relative;
  z-index: 1;
  line-height: 0;
  margin-top: -1px;
}

.dl-hero__wave svg {
  display: block;
  width: 100%;
  height: 56px;
}

@media (max-width: 800px) {
  .dl-hero {
    padding-top: 20px;
  }

  .dl-hero__card {
    padding: 20px 16px;
  }

  .dl-hero__inner {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .dl-hero__copy {
    text-align: center;
  }

  .dl-hero__title,
  .dl-hero__desc {
    margin-left: auto;
    margin-right: auto;
  }

  .dl-hero__meta {
    justify-content: center;
  }

  .dl-hero__visual {
    order: -1;
    width: 100%;
    min-height: 180px;
  }

  .dl-hero__art {
    margin: 0 auto;
    max-width: 220px;
  }

  .dl-hero__stamp {
    right: 18%;
    width: 72px;
    height: 72px;
    font-size: 12px;
  }
}
</style>
